import { useState, useCallback } from 'react';
import { getAllBundlesPaged } from '../../../service/BundleService'; 
import { desc, bundleId } from '../../../utility/commonConstant';

export const useBundles = () => {
    const [bundleList, setBundleList] = useState([]);

    const getBundles = useCallback(async (currentPage, pageSize, isActive, search = "") => {
        const response = await getAllBundlesPaged(currentPage - 1, pageSize, isActive, bundleId, desc,search);

        if (response?.success) {
            setBundleList(response.data?.content || []);
            return response.data;
        } else {
            setBundleList([]);
            return null;
        }
    }, []);

    return {
        bundleList,
        getBundles,
    };
};